import { Trans, useTranslation } from 'react-i18next'
import { getGraphQLErrorCode, USER_LIMIT_EXCEEDED_ERROR_CODE } from '../utils'
import { useErrorSnackbar } from './use-error-snackbar'

export const useAddUserToProfileError = () => {
  const { t } = useTranslation()
  const [showError] = useErrorSnackbar()

  return (error: unknown, profileName: string | undefined) =>
    showError(
      getGraphQLErrorCode(error) === USER_LIMIT_EXCEEDED_ERROR_CODE ? (
        // notistack renders the message in a flex container, which trims the
        // whitespace around <b>, so keep it all inside a single element.
        <span>
          <Trans
            t={t}
            i18nKey="error.userLimitExceeded"
            components={{ bold: <b /> }}
            values={{ name: profileName }}
          />
        </span>
      ) : undefined
    )
}
